import { api } from "./api";

export const orderList = (params) => {
  return api.get(`manufacturer/manage-orders/list`,{params});
};

export const orderDetail = (params) => {
  return api.get(`/manufacturer/manage-orders/manage-orders-view`, { params });
};
